module.exports = __webpack_public_path__ + "static/media/website-banner2.86afc945.jpg";